import { Box, Button, Stack, SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../../assets';
import PageTitle from '../../../components/shared/PageTitle';
import PageArea from '../../../components/shared/PageArea';
import { UserContext } from '../../../components/shared/useUser';
import { useNavigate } from 'react-router-dom';
import TenantsTab from './components/TenantsTab';

const TenantsPage = () => {
  const { t } = useTranslation('admin');
  const theme = useTheme();
  const navigate = useNavigate();

  const { hasPermissionTo } = useContext(UserContext);
  const [hasPermissionToCreate, setHasPermissionToCreate] = useState<boolean>(false);

  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  useEffect(() => {
    setHasPermissionToCreate(hasPermissionTo(['TenantCreate']));
  }, [hasPermissionTo]);

  const canView = hasPermissionTo(['TenantView']);

  if (!canView) {
    return null;
  }

  const onCreateNew = () => {
    navigate('/admin/tenants/create');
  };

  return (
    <PageArea>
      <Stack
        width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle subTitle={t('tenants.subtitle')}>{t('tenants.title')}</PageTitle>
        </Box>

        {hasPermissionToCreate && (
          <Box
            width={isMobile ? '100%' : 'auto'}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              variant="primary"
              size="lg"
              startIcon={<SvgIcon><Plus fill='white' /></SvgIcon>}
              onClick={onCreateNew}
              sx={{
                mb: { xs: 4, md: 0 },
              }}
            >
              {t('tenants.createNew')}
            </Button>
          </Box>
        )}
      </Stack>

      <TenantsTab onCreateNew={onCreateNew} />
    </PageArea>
  );
};

export default TenantsPage;
